<template>
  <div class="row justify-center q-my-md" v-show="loader">
    <q-spinner-dots color="primary" size="40px" />
  </div>
  
  
  <div class="imovel-detalhes" v-show="imovel.title">
    <!-- Galeria de Imagens -->
    
    <div class="galeria-section">
      <div class="container">
              
                <div>
      
                  <q-btn
                    flat
                    round
                    icon="arrow_back"
                    color="primary"
                    size="md"
                    class="q-mb-md"
                    @click="voltarLista"
                  >
                    <q-tooltip>Voltar</q-tooltip>
                  </q-btn>
                </div>
          
        

        <div class="row q-col-gutter-md">
          <!-- Imagem Principal -->
          <div class="col-12 col-md-8">
            <q-card flat class="main-image-card">
              <q-img
                :src="imagemPrincipal"
                :ratio="16/10"
                class="cursor-pointer"
                @click="abrirGaleria(0)"
              >
                <!-- Badge de Finalidade -->
                <div class="absolute-top-left q-ma-md">
                  <q-badge
                    :color="imovel.objective === 'Venda' ? 'green-7' : 'blue-7'"
                    class="text-bold text-uppercase q-pa-sm"
                    style="font-size: 14px;"
                  >
                    {{ imovel.objective }}
                  </q-badge>
                </div>

                <!-- Badge de Estado -->
                <div class="absolute-top-right q-ma-md">
                  <q-badge
                    :color="imovel.estado === 'novo' ? 'orange-7' : 'grey-7'"
                    class="text-bold text-uppercase q-pa-sm"
                    style="font-size: 14px;"
                  >
                    {{ imovel.condition }}
                  </q-badge>
                </div>

                <!-- Botões de Navegação -->
                <div class="absolute-bottom row justify-between full-width q-pa-md">
                  <q-btn
                    round
                    color="white"
                    text-color="grey-9"
                    icon="chevron_left"
                    @click.stop="imagemAnterior"
                  />
                  <q-btn
                    round
                    color="white"
                    text-color="grey-9"
                    icon="chevron_right"
                    @click.stop="proximaImagem"
                  />
                </div>

                <template v-slot:loading>
                  <q-spinner-gears color="primary" size="50px" />
                </template>
              </q-img>
            </q-card>
          </div>

          <!-- Miniaturas -->
          <div class="col-12 col-md-4">
            <div class="thumbnails-grid">
              <q-card
                v-for="(img, index) in imovel.imagens.slice(0, 4)"
                :key="index"
                flat
                bordered
                class="thumbnail-card cursor-pointer"
                :class="{ 'active': imagemAtual === index }"
                @click="selecionarImagem(index)"
              >
                <q-img :src="img" :ratio="1" />
                
                <!-- Overlay para "Ver mais" -->
                <div v-if="index === 3 && imovel.imagens.length > 4" class="thumbnail-overlay">
                  <div class="text-white text-bold text-h6">
                    +{{ imovel.imagens.length - 4 }}
                  </div>
                </div>
              </q-card>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Informações Principais -->
    <div class="info-section q-py-xl">
      <div class="container">
        <div class="row q-col-gutter-xl">
          <!-- Coluna Esquerda - Detalhes -->
          <div class="col-12 col-md-8">
            <!-- Título e Preço -->
            <div class="q-mb-lg">
              <div class="row items-center justify-between q-mb-sm">
                <h1 class="text-h4 text-weight-bold text-grey-9 q-ma-none">
                  {{ imovel.title }}
                </h1>
                <!-- <q-btn
                  flat
                  round
                  icon="favorite_border"
                  color="red-6"
                  size="lg"
                  @click="toggleFavorito"
                /> -->
              </div>

              <div class="row items-center q-mb-md">
                <q-icon name="location_on" color="primary" size="20px" />
                <span class="text-body1 text-grey-7 q-ml-xs">{{ imovel.location }}</span>
              </div>

              <div class="row items-center justify-between q-mb-lg">
                <div>
                  <div class="text-caption text-grey-7">
                    {{ imovel.objective === 'Venda' ? 'Preço' : 'Aluguel/mês' }}
                  </div>
                  <div class="text-h3 text-weight-bold text-primary">
                    {{ formatPrice(imovel.price, imovel.currency) }}
                  </div>
                </div>
                <q-chip
                  :icon="imovel.property_type === 'Casa' ? 'home' : 'apartment'"
                  color="primary"
                  text-color="white"
                  size="lg"
                  class="text-bold"
                >
                  {{ imovel.property_type }}
                </q-chip>
              </div>

              <q-separator />
            </div>

            <!-- Características Principais -->
            <div class="q-mb-xl">
              <h5 class="text-h6 text-weight-bold q-mb-md">Características</h5>
              <div class="row q-col-gutter-md">
                <div class="col-6 col-sm-4 col-md-3">
                  <q-card flat bordered class="caracteristica-card text-center q-pa-md">
                    <q-icon name="bed" color="primary" size="32px" />
                    <div class="text-h6 text-weight-bold q-mt-sm">{{ imovel.bedroom_amount }}</div>
                    <div class="text-caption text-grey-7">Quartos</div>
                  </q-card>
                </div>

                <div class="col-6 col-sm-4 col-md-3">
                  <q-card flat bordered class="caracteristica-card text-center q-pa-md">
                    <q-icon name="bathtub" color="primary" size="32px" />
                    <div class="text-h6 text-weight-bold q-mt-sm">{{ imovel.bathroom_amount }}</div>
                    <div class="text-caption text-grey-7">Banheiros</div>
                  </q-card>
                </div>

                <div class="col-6 col-sm-4 col-md-3">
                  <q-card flat bordered class="caracteristica-card text-center q-pa-md">
                    <q-icon name="square_foot" color="primary" size="32px" />
                    <div class="text-h6 text-weight-bold q-mt-sm">{{ imovel.area }}</div>
                    <div class="text-caption text-grey-7">m²</div>
                  </q-card>
                </div>

                <div class="col-6 col-sm-4 col-md-3">
                  <q-card flat bordered class="caracteristica-card text-center q-pa-md">
                    <q-icon name="directions_car" color="primary" size="32px" />
                    <div class="text-h6 text-weight-bold q-mt-sm">{{ imovel.garage_space }}</div>
                    <div class="text-caption text-grey-7">Vagas</div>
                  </q-card>
                </div>
              </div>
            </div>

            <!-- Descrição -->
            <div class="q-mb-xl">
              <h5 class="text-h6 text-weight-bold q-mb-md">Descrição</h5>
              <p class="text-body1 text-grey-8" style="line-height: 1.8;">
                {{ imovel.description }}
              </p>
            </div>
            <div class="q-mb-xl">
                <div class="col-6">
                  <q-btn                 
                    icon="delete"
                    color="red"
                    size="md"
                    class="q-mb-md"
                    @click="deleteProperty(imovel.slug)"
                  >
                    Eliminar Imovel
                  </q-btn>
                </div>
            </div>

            <!-- Comodidades -->
            <!-- <div class="q-mb-xl">
              <h5 class="text-h6 text-weight-bold q-mb-md">Comodidades</h5>
              <div class="row q-col-gutter-sm">
                <div
                  v-for="comodidade in imovel.comodidades"
                  :key="comodidade"
                  class="col-6 col-sm-4"
                >
                  <q-chip
                    icon="check_circle"
                    color="green-1"
                    text-color="green-9"
                    class="full-width"
                  >
                    {{ comodidade }}
                  </q-chip>
                </div>
              </div>
            </div> -->

            <!-- Localização no Mapa -->
            <!-- <div class="q-mb-xl">
              <h5 class="text-h6 text-weight-bold q-mb-md">Localização</h5>
              <q-card flat bordered>
                <div class="map-placeholder">
                  <q-icon name="map" size="48px" color="grey-5" />
                  <div class="text-body2 text-grey-7 q-mt-sm">
                    {{ imovel.localizacao }}
                  </div>
                </div>
              </q-card>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- Dialog para Galeria -->
    <q-dialog v-model="galeriaAberta" maximized>
      <q-card class="bg-black">
        <q-bar class="bg-transparent">
          <q-space />
          <q-btn flat dense icon="close" color="white" v-close-popup />
        </q-bar>

        <q-card-section class="flex flex-center" style="height: calc(100vh - 50px);">
          <q-carousel
            v-model="imagemAtual"
            animated
            navigation
            infinite
            arrows
            control-color="primary"
            class="galeria-carousel"
          >
            <q-carousel-slide
              v-for="(img, index) in imovel.imagens"
              :key="index"
              :name="index"
              :img-src="img"
            />
          </q-carousel>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import store from '@/vuex/store';
import Swal from 'sweetalert2';

const router = useRouter();
const imagemAtual = ref(0);
const galeriaAberta = ref(false);

const imovel = ref({
  title: '',
  slug: '',
  property_type: '',
  location: '',
  price: 0,
  currency: '',
  area: 0,
  bedroom_amount: 0,
  bathroom_amount: 0,
  garage_space: 0,
  condition: '',
  objective: '',
  description: '',
  imagens: [
  ]
});
let loader = ref(true);

const contato = ref({
  nome: '',
  email: '',
  telefone: '',
  mensagem: `Olá! Tenho interesse no imóvel - ${imovel.value.title}.`
});

const imagemPrincipal = computed(() => imovel.value.imagens[imagemAtual.value]);

const formatPrice = (price) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'MZN',
    minimumFractionDigits: 0
  }).format(price);
};
getImovel();
function getImovel() {
  store.dispatch('imovel/getImovelBySlug', router.currentRoute.value.params.slug)
    .then(res => {
      imovel.value = res
      loader.value = false;
      contato.value.mensagem = `Olá! Tenho interesse no imóvel - ${imovel.value.title}.`
    })
}
const voltarLista = () => {
  router.push('/imoveis');
};

const selecionarImagem = (index) => {
  imagemAtual.value = index;
};

const imagemAnterior = () => {
  if (imagemAtual.value > 0) {
    imagemAtual.value--;
  } else {
    imagemAtual.value = imovel.value.imagens.length - 1;
  }
};
function deleteProperty(slug) {
  //console.log(slug)
  Swal.fire({
            title: "Tem certeza?",
            text: `Você está prestes a eliminar este imovel, está accão é irreversivel.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `Sim, eliminar este imovel!`
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        await store.dispatch('imovel/destroy' ,slug)
                        Swal.fire({
                            title: `Imovél eliminado`,
                            text: "Imovél eliminado com sucesso",
                            icon: "success"
                        }).then(() => {
                          router.push("/imoveis")
                        });
                    } catch (error) {
                        console.error("Error updating user status:", error);
                        Swal.fire({
                            title: "Error!",
                            text: "Erro ao apagar este imovel, tente novamente.",
                            icon: "error"
                        });
                    }
                }
            });
}

const proximaImagem = () => {
  if (imagemAtual.value < imovel.value.imagens.length - 1) {
    imagemAtual.value++;
  } else {
    imagemAtual.value = 0;
  }
};

const abrirGaleria = (index) => {
  imagemAtual.value = index;
  galeriaAberta.value = true;
};

// const toggleFavorito = () => {
//   console.log('Toggle favorito');
// };


</script>

<style scoped>
.imovel-detalhes {
  min-height: 100vh;
  background: #f5f5f5;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 16px;
}

.galeria-section {
  background: white;
  padding: 24px 0;
}

.main-image-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.thumbnails-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  height: 100%;
}

.thumbnail-card {
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
}

.thumbnail-card:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.thumbnail-card.active {
  border: 3px solid var(--q-primary);
}

.thumbnail-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.info-section {
  background: #f5f5f5;
}

.caracteristica-card {
  border-radius: 12px;
  transition: all 0.3s ease;
}

.caracteristica-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}

.sticky-contact-card {
  position: sticky;
  top: 24px;
  border-radius: 16px;
}

.map-placeholder {
  height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #e0e0e0;
}

.galeria-carousel {
  width: 90vw;
  max-width: 1200px;
  height: 80vh;
}

.galeria-carousel :deep(.q-carousel__slide) {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

@media (max-width: 1023px) {
  .sticky-contact-card {
    position: relative;
    top: 0;
  }
}
</style>